import { Divider, Skeleton } from "@heroui/react";
import useUserDetails from "./hooks/data/use-user-details";
import { UserDetailReturnType } from "@/lib/declarations";
import useWalletBalances from "./hooks/data/use-wallet";
import WalletBalances from "@/app/api/wallet-balances/type";
import { useTranslations } from "next-intl";
import { formatNumber } from "@/lib/actionsHelper";

export default function NavbarUserDetails() {
  const t = useTranslations();
  const [details] = useUserDetails() as [UserDetailReturnType | undefined];
  const [balances] = useWalletBalances() as [WalletBalances[] | undefined];
  return (
    <>
      <span className="icon-icon58 text-[1.25rem]" />
      <Skeleton isLoaded={!!details}>
        <span className="text-sm">
          {t("balance")}: BDT {formatNumber(balances?.find((e) => e.category === "cash")?.balance || 0)}
        </span>
      </Skeleton>
      <Divider orientation="vertical" />
      <span className="icon-icon67 text-[1.25rem]" />
      <Skeleton isLoaded={!!details}>
        <span className="text-sm">{details?.user_information.username}</span>
      </Skeleton>
      <Divider orientation="vertical" />
    </>
  );
}
